import { render } from "./oaExamineComment.vue?vue&type=template&id=ce652f4e&scoped=true"
import script from "./oaExamineComment.vue?vue&type=script&lang=js"
export * from "./oaExamineComment.vue?vue&type=script&lang=js"

import "./oaExamineComment.vue?vue&type=style&index=0&id=ce652f4e&lang=css"
import "./oaExamineComment.vue?vue&type=style&index=1&id=ce652f4e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce652f4e"]])

export default __exports__